import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import type { EnvironmentResource, PropertyValueResource } from "@octopusdeploy/octopus-server-client";
import { EnvironmentMultiSelect } from "~/components/MultiSelect/EnvironmentMultiSelect";
import type { CommonTemplatesChangeTracker, CommonTemplatesKey } from "../useCommonTemplatesChangeTracker";
interface ScopedCommonTemplateScopeEditProps {
    environments: EnvironmentResource[];
    changeTracker: CommonTemplatesChangeTracker;
    scopeKey: CommonTemplatesKey;
    initialEnvironmentScope: string[];
    initialValue: PropertyValueResource | undefined;
}
export default function ScopedCommonTemplateScopeEdit({ environments, changeTracker, scopeKey, initialEnvironmentScope, initialValue }: ScopedCommonTemplateScopeEditProps) {
    const isEnvironmentIdsUnchanged = (initialEnvironmentScope: string[], scope: string[] | undefined): boolean => {
        if (!initialEnvironmentScope || !scope) {
            return initialEnvironmentScope === scope;
        }
        if (initialEnvironmentScope.length !== scope.length) {
            return false;
        }
        return initialEnvironmentScope.every((s, i) => s === scope[i]);
    };
    const isValueUnchanged = (value1: PropertyValueResource | undefined, value2: PropertyValueResource | undefined): boolean => {
        return value1 === value2;
    };
    const handleChange = (newScope: string[]) => {
        const entry = changeTracker.has(scopeKey) ? changeTracker.get(scopeKey) : undefined;
        const currentValue = entry?.value || initialValue;
        const environmentIdsUnchanged = isEnvironmentIdsUnchanged(initialEnvironmentScope, newScope);
        const valueUnchanged = isValueUnchanged(currentValue, initialValue);
        if (environmentIdsUnchanged && valueUnchanged) {
            changeTracker.remove(scopeKey);
        }
        else {
            changeTracker.set(scopeKey, { value: currentValue, environmentIds: newScope });
        }
    };
    const value = changeTracker.has(scopeKey) ? changeTracker.get(scopeKey)?.environmentIds || [] : initialEnvironmentScope;
    return (<div className={cellStyles.container}>
            <EnvironmentMultiSelect environments={environments} onChange={(environmentIds) => {
            handleChange(environmentIds);
        }} value={value}/>
        </div>);
}
const cellStyles = {
    container: css({
        marginLeft: space[8],
        marginRight: space[8],
    }),
};
